export const ImageDT = {
	image: {
		colorScheme: {
			light: {
				toolbar: {
					background: 'rgba(0, 0, 0, 0.2)',
				},
			},
			dark: {
				toolbar: {
					background: 'rgba(255, 255, 255, 0.2)',
				},
			},
		},
		css: (dt) => `
      .p-image-toolbar {
        mix-blend-mode: difference;
      }
    `,
	},
};
